<template>
<el-select :multiple="multipleFlag" :collapse-tags="multipleFlag" popper-class="eventlevel-combo" v-model="value" clearable @change="onChange" @clear="onClear">
  <el-option v-for="item in eventlevels" :key="item.eventlevelId" :label="item.eventlevelName" :value="item.eventlevelId" :style="`background:${item.eventlevelColorBg}`">
    <span :style="`color:${item.eventlevelColorText}`">{{ item.eventlevelName }}</span>
  </el-option>
</el-select>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WEventlevelCombo',
  props: {
    initValue: {
      type: String,
    },
    multipleFlag: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    eventlevels() {
      return this.$store.getters.eventlevelList;
    },
  },
  data() {
    return {
      value: null,
    };
  },
  mounted() {
    if (!isNil(this.initValue)) {
      this.value = this.initValue;
    }
    if (!isEmpty(this.eventlevels)) {
      this.$store.dispatch('loadEventlevelInfo');
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', value);
    },
    onClear() {
      this.$emit('clear');
    },
  },
};
</script>

<style lang="scss">
.eventlevel-combo {
  .el-select-dropdown__item {
    padding-left: 15px;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    margin: 2px;
    border-radius: 5px;
  }

  .el-select-dropdown__item.hover {
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/EventlevelCombo/EventlevelCombo.vue